import { type FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GrUpdate, GrList } from 'react-icons/gr';
import { Button } from 'react-bootstrap';

import { updatePageNumbers, generateNewGlossaryPage } from '@editor2/reducers/editor/effects';
import { tocTools } from '@editor2/containers/TableOfContentsPage/styles';
import { type RootState } from '@editor2/reducers/root';

interface Props {
	courseId: number;
}

const Tools: FC<Props> = (props) => {
	const { courseId } = props;

	const dispatch = useDispatch();

	const { headCommit } = useSelector((state: RootState) => state.courses[courseId]);
	const { canUpdateResource } = useSelector((state: RootState) => state.courses[courseId].policies);

	const onUpdatePageNumbers = () => {
		if (!canUpdateResource) return;

		// eslint-disable-next-line no-alert
		if (window.confirm('Are you sure you want to repaginate this TOC?')) {
			dispatch(updatePageNumbers({ courseId, resourceId: headCommit.thing_id }));
		}
	};

	const onGenerateNewGlossaryPage = () => {
		if (!canUpdateResource) return;

		// eslint-disable-next-line no-alert
		if (window.confirm('Are you sure you want to create or add a glossary?')) {
			dispatch(generateNewGlossaryPage({ courseId, resourceId: headCommit.thing_id }));
		}
	};

	return (
		<div className={tocTools}>
			<Button
				variant="light"
				className="toolsButton"
				onClick={onUpdatePageNumbers}
				disabled={!canUpdateResource}>
				<GrUpdate />
				Update page numbers
			</Button>

			<Button
				variant="light"
				className="toolsButton"
				onClick={onGenerateNewGlossaryPage}
				disabled={!canUpdateResource}>
				<GrList />
				Generate new glossary page
			</Button>
		</div>
	);
};

export default Tools;
